import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import MarketingLayout from "../components/layout/MarketingLayout";
import { useTheme } from "../context/ThemeContext";

const POLICY_ID = "WTFkSGJuUlZiblkxVjJSdFIzYzlQUT09";

// Apex routes — see PrivacyPolicy for explanation. Tenant Navbar/Footer
// is wrong at apex (broken nav links, wrong logo); use MarketingLayout.
const APEX_PATHS = new Set(["/terms", "/terms-of-service"]);

const TermsOfService: React.FC = () => {
  const { isDarkMode } = useTheme();
  const location = useLocation();
  const isApex = APEX_PATHS.has(location.pathname);
  const [policyHtml, setPolicyHtml] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`https://policies.termageddon.com/api/policy/${POLICY_ID}?render`)
      .then((res) => res.text())
      .then((html) => setPolicyHtml(html))
      .catch(() => setError(true));
  }, []);

  const policyBlock = (
    <div className="flex-1 py-8 sm:py-16 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h1 className={`text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 ${isApex || !isDarkMode ? 'text-gray-800' : 'text-white'}`}>
            Terms of Service
          </h1>
        </div>

        <div className={`rounded-lg shadow-md p-6 sm:p-8 ${!isApex && isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
          {policyHtml ? (
            <div
              className={`prose max-w-none ${!isApex && isDarkMode ? 'text-gray-300 prose-headings:text-white prose-a:text-blue-400' : 'text-gray-700'}`}
              dangerouslySetInnerHTML={{ __html: policyHtml }}
            />
          ) : error ? (
            <p className={`text-center ${!isApex && isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Unable to load the policy. Please{" "}
              <a
                rel="nofollow noreferrer"
                href={`https://policies.termageddon.com/api/policy/${POLICY_ID}`}
                target="_blank"
                className="text-blue-500 hover:underline"
              >
                click here
              </a>{" "}
              to view the policy.
            </p>
          ) : (
            <p className={`text-center ${!isApex && isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Loading policy...</p>
          )}
        </div>
      </div>
    </div>
  );

  if (isApex) {
    return <MarketingLayout>{policyBlock}</MarketingLayout>;
  }

  return (
    <div className={`min-h-screen flex flex-col ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <Navbar />
      {policyBlock}
      <Footer />
    </div>
  );
};

export default TermsOfService;
